var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement, createContext, useContext } from "react";
export const createSingletonHook = (useHook) => {
    const Context = createContext(undefined);
    const SingletonHookProvider = (_a) => {
        var { children } = _a, props = __rest(_a, ["children"]);
        const value = useHook(props);
        return createElement(Context.Provider, { value }, children);
    };
    const useSingletonHook = () => {
        const value = useContext(Context);
        if (typeof value === "undefined")
            throw new Error();
        return value;
    };
    return [useSingletonHook, SingletonHookProvider];
};
